import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../helpers/inputTextLimit';

const validate = values => {
    const errors = {};

    if (!values.name) {
        errors.name = messages.required;
    } else if (values.name.trim() == "") {
        errors.name = messages.required;
    } else if (values?.name?.length > inputTextLimit) {
        errors.name = messages.textAreaError
    }

    if (!values.description) {
        errors.description = messages.required;
    } else if (values.description.trim() == "") {
        errors.description = messages.required;
    } else if (values?.description?.length > inputDescLimit) {
        errors.description = messages.descLimitError;
    }

    if (!values.categoryId) {
        errors.categoryId = messages.required;
    }

    return errors;
};

export default validate